export enum PaymentStatus {
  INVALID = 0,
  UNPAID = 1,
  PAID = 2,
}

export interface PaymentDetails {
  status: PaymentStatus;
  // E.g. "Due in 3 Days",
  statusDescription: string;
  totalAmount: number;
  amountPaid: number;
  amountLeftToPay: number;
  dueDate: Date;
}
